import { RouteHelper } from '@ers/helpers';
import { useRouter } from '.';

const useSimpleLayout = () => {
    const { location } = useRouter();
    const activeByUrl = RouteHelper.getActiveItemByPath(location.pathname);
    return activeByUrl ? activeByUrl.simpleLayout : true;
};
export default useSimpleLayout;
